import { LOCALES } from 'i18n/locales';
export const loggedOutIntl = {
    [LOCALES.ENGLISH]: {
        'loggedOut.message': 'You have been signed out.'
    },
    [LOCALES.WELSH]: {
        'loggedOut.message': 'Rydych wedi cael eich allgofnodi'
    }
};
